import React, { useState } from "react";
import DisplayPropertyWithEdit from "../../common/DisplayPropertyWithEdit";
import EditIcon from "@mui/icons-material/Edit";
import DoneIcon from "@mui/icons-material/Done";
import "./MyProfile.css";
//MUI Components
import { Tooltip } from "@mui/material";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import SettingsAccessibilityIcon from "@mui/icons-material/SettingsAccessibility";
import WorkIcon from "@mui/icons-material/Work";
import GroupsIcon from "@mui/icons-material/Groups";
import InterestsIcon from "@mui/icons-material/Interests";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
//Detail components
import CareerDetails from "./CareerDetails";
import PersonalDetails from "./PersonalDetails";
import SocialDetails from "./SocialDetails";
import OtherDetails from "./OtherDetails";
import FamilyDetails from "./FamilyDetails";
import AboutDetails from "./AboutDetails";
import { Link } from "react-router-dom";
//toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useAuth from "../../hooks/useAuth";
import {
  getUploadData,
  updateProfile,
  updateProfileImage,
} from "../../../services/profile";
import { getAge } from "../../common/utilities/AgeCalculator";
import { changePassword } from "../../../services/auth";
import { BACKEND_IMAGE_URL } from "../../../services/Constants";
import NavigationBlocker from "../../common/NavigationBlocker";
import { 
  PROFILE_UPLOAD_IMAGE_LIMIT, 
  PROFILE_UPLOAD_STATUS_GETUPLOADDATA_FAILED, 
  PROFILE_UPLOAD_STATUS_NOT_SELECTED, 
  PROFILE_UPLOAD_STATUS_RESTORE_FAILED, 
  PROFILE_UPLOAD_STATUS_UPLOADED,
  UPLOAD_TIMEOUT,
  IMAGE_FETCH_TIMEOUT,
  IMAGE_RESTORE_PLACEHOLDER_MESSAGE,
  IMAGE_RESTORE_SUCCESS_MESSAGE,
  IMAGE_RESTORE_PARTIAL_SUCCESS_MESSAGE,
  IMAGE_RESTORE_FAILED_MESSAGE,
  PROFILE_UPLOAD_STATUS_UPLOADING
} from "../../constants/Constants";
import ProfileImage from "../ProfileImage";
import { UPLOAD_DATA_FAILED_MESSAGE } from "../CreateProfile/ProfileContext";

const MyProfilePage = () => {
  const { profile, setProfile, getToken } = useAuth();
  const [myProfile, setMyProfile] = React.useState(null);
  const [validationError, setValidationError] = React.useState("");
  //Personal details
  const [name, setName] = React.useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  // Career Details
  const [qualifications, setQualification] = useState([]);
  const [occupation, setOccupation] = useState("");
  const [employedIn, setEmployedIn] = useState("");
  const [annualIncome, setAnnualIncome] = useState("");
  const [isNRI, setIsNRI] = useState(false);
  // Social Details
  const [languagesKnown, setLanguagesKnown] = useState([]);
  const [maritalStatus, setMaritalStatus] = useState("");
  const [motherTongue, setMotherTongue] = useState("");
  const [religion, setReligion] = useState("");
  const [caste, setCaste] = useState("");

  const [gotra, setGotra] = useState("");
  const [kuldevta, setKuldevta] = useState("");
  const [nakshatra, setNakshatra] = useState("");
  const [rashi, setRashi] = useState("");
  //Other details
  const [bloodGroup, setBloodGroup] = useState("");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [foodHabits, setFoodHabits] = useState("");
  const [drinkingHabits, setDrinkHabits] = useState("");
  const [smokingHabits, setSmokeHabits] = useState("");
  //Familydetails
  const [fatherName, setFatherName] = useState("");
  const [fatherNumber, setFatherNumber] = useState("");
  const [motherName, setMotherName] = useState("");
  const [motherNumber, setMotherNumber] = useState("");
  //About details
  const [contactNumber, setContactNumber] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [bio, setBio] = useState("");
  const [userPreferences, setUserPreferences] = useState("");
  const [math, setMath] = useState("");
  let timestamp = new Date().getTime();
  const [isDirty, setIsDirty] = useState(false);

  // Add new state for multiple images
  const [profileImageUploadUrls, setProfileImageUploadUrls] = useState([]);
  const [profileImageUploadStatuses, setProfileImageUploadStatuses] = useState(new Array(PROFILE_UPLOAD_IMAGE_LIMIT).fill(PROFILE_UPLOAD_STATUS_UPLOADING));

  const [localProfileImageUrls, setLocalProfileImageUrls] = useState([]);
	const [profileUploadDataKeys, setProfileUploadDataKeys] = useState([]);

  const [data, setData] = useState({
    firstName: {
      label: "firstName",
      errorPage: "personal",
      helperText: "Please enter a valid first name",
      error: false,
    },
    lastName: {
      label: "lastName",
      errorPage: "personal",
      helperText: "Please enter a valid last name",
      error: false,
    },
    age: {
      label: "age",
      errorPage: "personal",
      helperText: "Please enter a valid age",
      error: false,
    },
    gender: {
      label: "gender",
      errorPage: "personal",
      helperText: "Please enter a valid gender",
      error: false,
    },
    city: {
      label: "city",
      errorPage: "personal",
      helperText: "Please enter a valid city name",
      error: false,
    },
    state: {
      label: "state",
      errorPage: "personal",
      helperText: "Please enter a valid state name",
      error: false,
    },
    country: {
      label: "country",
      errorPage: "personal",
      helperText: "Please enter a valid country name",
      error: false,
    },
    qualifications: {
      label: "qualifications",
      errorPage: "career",
      helperText: "Please enter a valid qualification",
      error: false,
    },
    occupation: {
      label: "occupation",
      errorPage: "career",
      helperText: "Please enter a valid occupation",
      error: false,
    },
    employedIn: {
      label: "employedIn",
      errorPage: "career",
      helperText: "Please enter a valid employedIn",
      error: false,
    },
    annualIncome: {
      label: "annualIncome",
      errorPage: "career",
      helperText: "Please enter a valid annual income",
      error: false,
    },
    languagesKnown: {
      label: "languagesKnown",
      errorPage: "social",
      helperText: "Please enter a valid language",
      error: false,
    },
    maritalStatus: {
      label: "maritalStatus",
      errorPage: "social",
      helperText: "Please enter a valid marital status",
      error: false,
    },
    motherTongue: {
      label: "motherTongue",
      errorPage: "social",
      helperText: "Please enter a valid mother tongue",
      error: false,
    },
    religion: {
      label: "religion",
      errorPage: "social",
      helperText: "Please enter a valid religion",
      error: false,
    },
    caste: {
      label: "caste",
      errorPage: "social",
      helperText: "Please enter a valid caste",
      error: false,
    },
    gotra: {
      label: "gotra",
      errorPage: "social",
      helperText: "Please enter a valid gotra",
      error: false,
    },
    rashi: {
      label: "rashi",
      errorPage: "social",
      helperText: "Please enter a valid rashi",
      error: false,
    },
    kuldevta: {
      label: "kuldevta",
      errorPage: "social",
      helperText: "Please enter a valid kuldevta",
      error: false,
    },
    nakshatra: {
      label: "nakshatra",
      errorPage: "social",
      helperText: "Please enter a valid nakshatra",
      error: false,
    },
    bloodGroup: {
      label: "bloodGroup",
      errorPage: "other",
      helperText: "Please enter a valid blood group",
      error: false,
    },
    foodHabits: {
      label: "foodHabits",
      errorPage: "other",
      helperText: "Please enter a valid food habit",
      error: false,
    },
    drinkingHabits: {
      label: "drinkingHabits",
      errorPage: "other",
      helperText: "Please enter a valid input",
      error: false,
    },
    smokingHabits: {
      label: "smokingHabits",
      errorPage: "other",
      helperText: "Please enter a valid input",
      error: false,
    },
    height: {
      label: "height",
      errorPage: "other",
      helperText: "Please enter a valid height",
      error: false,
    },
    weight: {
      label: "weight",
      errorPage: "other",
      helperText: "Please enter a valid weight",
      error: false,
    },

    fatherName: {
      label: "fatherName",
      errorPage: "family",
      helperText: "Please enter a valid father name",
      error: false,
    },
    fatherNumber: {
      label: "fatherNumber",
      errorPage: "family",
      helperText: "Please enter a valid father number",
      error: false,
    },
    motherName: {
      label: "motherName",
      errorPage: "family",
      helperText: "Please enter a valid mothers name",
      error: false,
    },
    motherNumber: {
      label: "motherNumber",
      errorPage: "family",
      helperText: "Please enter a valid mothers number",
      error: false,
    },
    contactNumber: {
      label: "contactNumber",
      errorPage: "aboutMe",
      helperText: "Please enter a Contact number",
      error: false,
    },
    bio: {
      label: "bio",
      errorPage: "aboutMe",
      helperText: "Please enter a valid bio",
      error: false,
    },
    userPreferences: {
      label: "userPreferences",
      errorPage: "aboutMe",
      helperText: "Please enter your partner preferences",
      error: false,
    },
    math: {
      label: "math",
      errorPage: "social",
      helperText: "Please select your math",
      error: false,
    },
    profileImage: {
      label: "profileImage",
      errorPage: "aboutMe",
      helperText: "Please enter a valid Image",
      error: false,
    },
    isNRI: {
      label: "isNRI",
      errorPage: "career",
      helperText: "Please enter a valid input for NRI",
      error: false,
    },
  });

  const updateProfileObject = (profile, key, value) => {
    let tempProfile = { ...profile };
    tempProfile[key] = value;
    return tempProfile;
  };

  const updateProfileInBackEnd = async (callback) => {
    const successCallback = () => {
      toast.success("Profile updated successfully", {
        timeOut: 1000,
      });
      setIsDirty(false);
      if (callback) callback();
    };

    try {
      let token = getToken()?.token;
      if (!token) {
        toast.error("There is some error in updating profile, please try again later", {
          timeOut: 1000,
        });
        return;
      }
      const escapedBio = bio.replace(/\n/g, "\\n");
      const escapedUserPreferences = userPreferences.replace(/\n/g, "\\n");
      let profileUpdate = {
        ...myProfile,
        dob: profile.dob,
        bio: escapedBio,
        userPreferences: escapedUserPreferences,
      }

      let response = await updateProfile(token, profileUpdate);
      if (response.data.errors) {
        toast.error("Failed to update profile", {
          timeOut: 1000,
        });
        return;
      }

      // Get all uploaded image keys
      const uploadedKeys = profileImageUploadStatuses
        .map((status, index) => status === PROFILE_UPLOAD_STATUS_UPLOADED ? profileUploadDataKeys[index] : null)
        .filter(key => key !== null);

      if (uploadedKeys.length > 0) {
        let imageAssociateResponse = await updateProfileImage(token, uploadedKeys);
        if (imageAssociateResponse.data.errors) {
          const errorMsg = imageAssociateResponse.data?.errors[0]?.message?.toLowerCase() ?? "";
          if (errorMsg.includes("partial success")) {
            toast.warning("Some images were uploaded successfully. Please refresh the page to retry uploading the remaining images.", {
              timeOut: 5000,
            });
            myProfile.isImageAvailable = true;
            myProfile.photoKeys = uploadedKeys;
            setProfile(myProfile);
            setMyProfile(myProfile);
            successCallback();
            return;
          }
          toast.error("Failed to update profile images, please try again later", {
            timeOut: 1000,
          });
          return;
        }
        // Update profile with new photo keys
        myProfile.photoKeys = uploadedKeys;
        myProfile.isImageAvailable = true;
      } else {
        toast.info("No images available - skipping image update", {
          timeOut: 1000,
        });
      }
      setProfile(myProfile);
      setMyProfile(myProfile);
      successCallback();
    } catch (error) {
      console.error("Error in updating profile", error);
      toast.error("Failed to update profile", {
        timeOut: 1000,
      });
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (!name.includes("Password")) {
      // contact email is not mandatory no need to check
      if (name !== "contactEmail") {
        if (!value.length) {
          let smallData = { ...data };
          smallData[name].error = true;
          setData(smallData);
          setValidationError(data[name].errorPage);
        } else {
          let smallData = { ...data };
          smallData[name].error = false;
          setData(smallData);
          setValidationError("");
        }
      }

      if (
        name === "isNRI"
      ) {
        let updatedProfile = updateProfileObject(
          myProfile,
          name,
          event.target.checked
        );
        setMyProfile(updatedProfile);
      } else {
        let updatedProfile = updateProfileObject(myProfile, name, value);
        setMyProfile(updatedProfile);
      }
    }
    // console.log('new Profile is', updatedProfile);
    switch (name) {
      //Personal details
      case "firstName":
        setFirstName(value);
        setName(value + " " + lastName);
        break;
      case "lastName":
        setLastName(value);
        setName(firstName + " " + value);
        break;
      case "age":
        setAge(value);
        break;
      case "gender":
        setGender(value);
        break;
      case "city":
        setCity(value);
        break;
      case "state":
        setState(value);
        break;
      case "country":
        setCountry(value);
        break;

      // Career Details
      case "qualifications":
        setQualification(
          // On autofill we get a stringified value.
          typeof value === "string" ? value.split(", ") : value
        );
        break;
      case "occupation":
        setOccupation(value);
        break;
      case "employedIn":
        setEmployedIn(value);
        break;
      case "annualIncome":
        setAnnualIncome(value);
        break;
      case "isNRI":
        setIsNRI(event.target.checked);
        break;

      // Social Details
      case "languagesKnown":
        setLanguagesKnown(
          // On autofill we get a stringified value.
          typeof value === "string" ? value.split(", ") : value
        );
        break;
      case "maritalStatus":
        setMaritalStatus(value);
        break;
      case "motherTongue":
        setMotherTongue(value);
        break;
      case "religion":
        setReligion(value);
        break;
      case "caste":
        setCaste(value);
        break;
      case "gotra":
        setGotra(value);
        break;
      case "kuldevta":
        setKuldevta(value);
        break;
      case "nakshatra":
        setNakshatra(value);
        break;
      case "rashi":
        setRashi(value);
        break;

      //Other details
      case "bloodGroup":
        setBloodGroup(value);
        break;
      case "height":
        setHeight(value);
        break;
      case "weight":
        setWeight(value);
        break;
      case "foodHabits":
        setFoodHabits(value);
        break;
      case "drinkingHabits":
        setDrinkHabits(value);
        break;
      case "smokingHabits":
        setSmokeHabits(value);
        break;

      //Familydetails
      case "fatherName":
        setFatherName(value);
        break;
      case "fatherNumber":
        setFatherNumber(value);
        break;
      case "motherName":
        setMotherName(value);
        break;
      case "motherNumber":
        setMotherNumber(value);
        break;

      //About details
      case "bio":
        setBio(value);
        break;
      case "userPreferences":
        setUserPreferences(value);
        break;
      case "contactNumber":
        setContactNumber(value);
        break;
      case "contactEmail":
        setContactEmail(value);
        break;
      case "math":
        setMath(value);
        break;

      //Password
      case "oldPassword":
        setOldPassword(value);
        break;
      case "newPassword":
        setNewPassword(value);
        break;
      case "confirmPassword":
        setConfirmPassword(value);
        break;
      default:
        return;
    }
    !isDirty && setIsDirty(true);
  };

  React.useEffect(() => {
    let ageString = getAge(profile.dob);

    setMyProfile(profile);
    //PERSONAL DETAILS
    setFirstName(profile.firstName);
    setLastName(profile.lastName);
    setAge(ageString);
    setName(profile.firstName + " " + profile.lastName);
    setGender(profile.gender);
    setCity(profile.city);
    setState(profile.state);
    setCountry(profile.country);
    //CAREER DETAILS
    setQualification(profile.qualifications);
    setOccupation(profile.occupation);
    setEmployedIn(profile.employedIn);
    setAnnualIncome(profile.annualIncome);
    setIsNRI(profile.isNri);
    //SOCIAL DETAILS
    setLanguagesKnown(profile.languagesKnown);
    setMaritalStatus(profile.maritalStatus);
    setMotherTongue(profile.motherTongue);
    setReligion(profile.religion);
    setCaste(profile.caste);
    setGotra(profile.gotra);
    setKuldevta(profile.kuldevta);
    setNakshatra(profile.nakshatra);
    setRashi(profile.rashi);
    //OTHER DETAILS
    setBloodGroup(profile.bloodGroup);
    setHeight(profile.height);
    setWeight(profile.weight);
    setFoodHabits(profile.foodHabits);
    setDrinkHabits(profile.drinkingHabits);
    setSmokeHabits(profile.smokingHabits);
    //FAMILY DETAILS
    setFatherName(profile.fatherName);
    setFatherNumber(profile.fatherNumber);
    setMotherName(profile.motherName);
    setMotherNumber(profile.motherNumber);
    //ABOUT DETAILS
    setBio(profile.bio);
    setUserPreferences(profile.userPreferences);
    setContactNumber(profile.contactNumber);
    setContactEmail(profile.contactEmail);
    setMath(profile.math);
    // setProfileImage(profile.profileImage);
  }, []);
  
  React.useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      // Most browsers display a default prompt message.
      e.returnValue = '';
    };
    if(isDirty) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }
		
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isDirty])

  const [isPersonalEditable, setIsPersonalEditable] = React.useState(false);
  const [isCareerEditable, setIsCareerEditable] = React.useState(false);
  const [isSocialEditable, setIsSocialEditable] = React.useState(false);
  const [isOtherEditable, setIsOtherEditable] = React.useState(false);
  const [isFamilyEditable, setIsFamilyEditable] = React.useState(false);
  const [isAboutEditable, setIsAboutEditable] = React.useState(false);
  const [changePasswordOpen, setChangePasswordOpen] = React.useState(false);
  const [oldPassword, setOldPassword] = React.useState("");
  const [oldPasswordError, setOldPasswordError] = React.useState(false);
  const [newPassword, setNewPassword] = React.useState("");
  const [newPasswordError, setNewPasswordError] = React.useState(false);
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [confirmPasswordError, setConfirmPasswordError] = React.useState(false);
  const handleOpen = () => setChangePasswordOpen(true);
  const handleClose = () => setChangePasswordOpen(false);
  const [emptyFields, setEmptyFields] = useState([]);
  const token = getToken()?.token ?? ""
  const checkForEmptyFields = (profileData) => {
    const fields = [
      { label: "First Name", value: profileData.firstName },
      { label: "Last Name", value: profileData.lastName },
      { label: "Age", value: getAge(profileData.dob) },
      { label: "Gender", value: profileData.gender },
      { label: "City", value: profileData.city },
      { label: "State", value: profileData.state },
      { label: "Country", value: profileData.country },
      { label: "Occupation", value: profileData.occupation },
      { label: "Employed In", value: profileData.employedIn },
      { label: "Annual Income", value: profileData.annualIncome },
      { label: "Marital Status", value: profileData.maritalStatus },
      { label: "Mother Tongue", value: profileData.motherTongue },
      { label: "Caste", value: profileData.caste },
      { label: "Gotra", value: profileData.gotra },
      { label: "Kuldevta", value: profileData.kuldevta },
      { label: "Nakshatra", value: profileData.nakshatra },
      { label: "Rashi", value: profileData.rashi },
      {
        label: "Languages Known",
        value:
          profileData.languagesKnown.length > 0
            ? profileData.languagesKnown.join(", ")
            : "",
      },
      { label: "Blood Group", value: profileData.bloodGroup },
      { label: "Height", value: profileData.height },
      { label: "Weight", value: profileData.weight },
      { label: "Food Habits", value: profileData.foodHabits },
      {
        label: "Drinking Habits",
        value: profileData.drinkingHabits,
      },
      {
        label: "Smoking Habits",
        value: profileData.smokingHabits,
      },
      { label: "Father's Name", value: profileData.fatherName },
      { label: "Father's Number", value: profileData.fatherNumber },
      { label: "Mother's Name", value: profileData.motherName },
      { label: "Mother's Number", value: profileData.motherNumber },
      { label: "Contact Number", value: profileData.contactNumber },
      { label: "Contact Email", value: profileData.contactEmail },
      { label: "Bio", value: profileData.bio },
      { label: "Partner Preferences", value: profileData.userPreferences },
      { label: "Math", value: profileData.math },
    ];

    const emptyFieldsList = fields
      .filter((field) => !field.value || field.value === "")
      .map((field) => field.label);
    setEmptyFields(emptyFieldsList);
  };
  React.useEffect(() => {
    if (profile && token) {
      checkForEmptyFields(profile);
    }
  }, [profile]);

  const fetchProfileUploadData = async (showRestoreMessage = false) => {
    try {
      let token = getToken()?.token;
      let response = await getUploadData(token);
			if (response.errors) {
				setProfileImageUploadStatuses(new Array(PROFILE_UPLOAD_IMAGE_LIMIT).fill(PROFILE_UPLOAD_STATUS_GETUPLOADDATA_FAILED));
        toast.error(UPLOAD_DATA_FAILED_MESSAGE);
        return null;
			}
      const uploadData = response.data.getUploadData;
      
      // Initialize arrays for each upload data
      const urls = uploadData.map(data => data.url);
      const keys = uploadData.map(data => data.key);
      const statuses = new Array(uploadData.length).fill(PROFILE_UPLOAD_STATUS_NOT_SELECTED);
      const localUrls = new Array(uploadData.length).fill("");
      
      // If there are existing profile images, restore them in parallel
      if (myProfile?.photoKeys?.length > 0) {
        // Show placeholder message
        if (showRestoreMessage) {
          toast.info(IMAGE_RESTORE_PLACEHOLDER_MESSAGE, {
            timeOut: 3000,
          });
        }
        
        // Create array of promises for parallel execution
        const restorePromises = myProfile.photoKeys.slice(0, uploadData.length).map(async (photoKey, index) => {
          const existingImageUrl = `${BACKEND_IMAGE_URL}/images/profile?photoKey=${photoKey}&t=${timestamp}`;
          try {
            // Fetch the existing image
            const imageResponse = await fetch(existingImageUrl, {
              signal: AbortSignal.timeout(IMAGE_FETCH_TIMEOUT)
            });
            const imageBlob = await imageResponse.blob();
            
            // Upload to new path
            const uploadResponse = await fetch(urls[index], {
              method: 'PUT',
              body: imageBlob,
              headers: {
                'Content-Type': imageBlob.type
              },
              signal: AbortSignal.timeout(UPLOAD_TIMEOUT)
            });            

						if(uploadResponse.status !== 200) {
							return {
								index,
								success: false,
								localUrl: existingImageUrl,
								status: PROFILE_UPLOAD_STATUS_RESTORE_FAILED
							};
						}

            return {
              index,
              success: true,
              localUrl: existingImageUrl,
              status: PROFILE_UPLOAD_STATUS_UPLOADED
            };
          } catch (error) {
            console.error('Error uploading existing image:', error);
            return {
              index,
              success: false,
              localUrl: existingImageUrl,
              status: PROFILE_UPLOAD_STATUS_RESTORE_FAILED
            };
          }
        });
        
        // Wait for all promises to resolve
        const results = await Promise.allSettled(restorePromises);
        
        // Process results
        let isPartialFailure = false;
        results.forEach((result) => {
          if (result.status === 'fulfilled') {
            const { index, success, localUrl, status } = result.value;
            localUrls[index] = localUrl;
            statuses[index] = status;
            if (!success) {
              isPartialFailure = true;
            }
          }
        });
        
        // Set remaining slots to NOT_SELECTED
        for (let i = myProfile.photoKeys.length; i < uploadData.length; i++) {
          statuses[i] = PROFILE_UPLOAD_STATUS_NOT_SELECTED;
          localUrls[i] = "";
        }
        
        // Show appropriate message based on results
        if (isPartialFailure) {
          toast.warning(IMAGE_RESTORE_PARTIAL_SUCCESS_MESSAGE, {
            timeOut: 5000,
          });
        } else if (showRestoreMessage) {
          toast.success(IMAGE_RESTORE_SUCCESS_MESSAGE, {
            timeOut: 5000,
          });
        }
      }
      
      setProfileImageUploadUrls(urls);
      setProfileUploadDataKeys(keys);
      setProfileImageUploadStatuses(statuses);
      setLocalProfileImageUrls(localUrls);
      
      return urls;
    } catch(error) {
      toast.error(IMAGE_RESTORE_FAILED_MESSAGE, {
        timeOut: 3000,
      });
      return null;
    }
  };

  const handlePasswordChange = async () => {
    // console.log('debug updating password', {
    // 	oldPassword,
    // 	newPassword,
    // 	confirmPassword,
    // });
    let isError = false;
    setOldPasswordError(false);
    setNewPasswordError(false);
    setConfirmPasswordError(false);
    if (oldPassword === "") {
      setOldPasswordError(true);
      isError = true;
    }
    if (newPassword === "") {
      setNewPasswordError(true);
      isError = true;
    }
    if (newPassword !== confirmPassword) {
      setConfirmPasswordError(true);
      isError = true;
    }

    if (isError) {
      return;
    } else {
      try {
        // console.log('debug updating backend fetching token');
        let auth = getToken();
        if (auth) {
          let response = await changePassword(
            auth.token,
            oldPassword,
            newPassword
          );
          if (response.data?.changePassword) {
            toast.success("Password updated successfully");
            setChangePasswordOpen(false);
            setOldPassword("");
            setNewPassword("");
            setConfirmPassword("");
          } else {
            // console.error(
            // 	'password api update failed',
            // 	response.errors
            // );
            toast.error("Password Update failed");
          }
        } else {
          // console.error('token not found when updating password');
        }
      } catch (error) {
        toast.error("Password updated failed");
        // console.error('error in updating password', error);
      }
    }
  };

  return (
    <div className="my-profile px-2">
      <ToastContainer autoClose={2000} />
      <NavigationBlocker when={isDirty} message={"Changes you made may not be saved"}/>
      
      <div className={`empty-fields-section p-4 bg-red-100 border-l-4 border-red-500 text-red-700 rounded-lg shadow-md max-w-7xl mx-auto mt-10 ${emptyFields.length === 0 ? 'hidden' :'block'}`}>
        {emptyFields.length > 0 && (
          <div className="empty-fields flex flex-col sm:flex-row items-start space-x-3">
            <h3 className="text-lg font-semibold whitespace-nowrap">
              Please fill these fields:
            </h3>
            <ul className="flex flex-wrap gap-2">
              {emptyFields.map((field, index) => (
                <li
                  key={index}
                  className="flex items-center space-x-2 bg-white px-3 py-1 rounded-full text-sm text-gray-700 shadow-sm border border-gray-300"
                >
                  <span className="text-red-600 font-semibold">•</span>
                  <span>{field}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <div className="container">
        <div
          style={{
            width: "100%",
            display: "flex",
            marginTop: "80px",
            placeContent: "center",
          }}
        >
          <h1 className="font-bold">My Profile </h1>

          <Modal
            open={changePasswordOpen}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            {/* Change password  */}
            <Box
              sx={{
                width: "90%",
                maxWidth: "sm",
                mx: "auto",
                my: "20vh",
                p: 4,
                bgcolor: "white",
                borderRadius: "md",
                boxShadow: "md",
              }}
              className="relative bg-white p-6 rounded-lg shadow-lg"
            >
              <h2 id="modal-modal-title" className="text-center font-bold">
                Change Password
              </h2>
              <p id="modal-modal-description">
                <div>
                  <TextField
                    required
                    id="oldPassword"
                    name="oldPassword"
                    type="password"
                    label="Old Password"
                    fullWidth
                    variant="standard"
                    onChange={handleChange}
                    value={oldPassword}
                    placeholder="Enter old password"
                    error={oldPasswordError}
                    helperText={oldPasswordError ? "Enter old password" : ""}
                  />
                </div>
                <div>
                  <TextField
                    required
                    fullWidth
                    variant="standard"
                    label="New Password"
                    placeholder="Enter new password"
                    type="password"
                    name="newPassword"
                    value={newPassword}
                    onChange={handleChange}
                    error={newPasswordError}
                    helperText={newPasswordError ? "Password mismatch" : ""}
                  />
                </div>
                <div>
                  <TextField
                    required
                    fullWidth
                    variant="standard"
                    label="Confirm Password"
                    placeholder="Confirm new password"
                    type="password"
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={handleChange}
                    error={confirmPasswordError}
                    helperText={confirmPasswordError ? "Password mismatch" : ""}
                  />
                </div>
                <center>
                  <button
                    type="submit"
                    variant="primary"
                    onClick={handlePasswordChange}
                    className="bg-blue-600 text-white hover:bg-blue-600 focus:ring-2 focus:ring-blue-500 w-full mt-2 py-2"
                  >
                    Submit
                  </button>
                </center>
              </p>
            </Box>
          </Modal>
        </div>

        <Box>
          <Stepper nonLinear={true} orientation="vertical">
            {/* ABOUT ME  */}
            <Step key={0}>
              <StepLabel
                StepIconComponent={AccountBoxIcon}
                className="text-blue-700"
              ></StepLabel>
              <StepContent>
                {myProfile && (
                  <div className="flex flex-col items-center mt-4 mb-4 space-y-4">
                    <div className="w-full p-4 rounded-lg bg-gray-100 shadow-md">
                      <div className="flex justify-between items-center">
                        <h3 className="text-xl font-bold">About Me</h3>
                        <button
                          className="btn btn-primary btn-sm z-10"
                          onClick={() => {
                            if (validationError !== "aboutMe") {
                              if (isAboutEditable) {
                                updateProfileInBackEnd(() => {
                                  setIsAboutEditable(false);
                                });
                              } else {
                                setIsAboutEditable(true);
                              }
                            }
                          }}
                        >
                          {isAboutEditable ? (
                            <Tooltip title="Save">
                              <DoneIcon className="text-white" />
                            </Tooltip>
                          ) : (
                            <Tooltip title="Edit">
                              <EditIcon className="text-white" />
                            </Tooltip>
                          )}
                        </button>
                      </div>

                      {isAboutEditable ? (
                        <AboutDetails
                          bio={bio}
                          handleChange={handleChange}
                          data={data}
                          fetchProfileUploadData={fetchProfileUploadData}
                          contactNumber={contactNumber}
                          contactEmail={contactEmail}
                          userPreferences={userPreferences}
                          setIsDirty={setIsDirty}
                          isDirty={isDirty}
                          profileImageUploadUrls={profileImageUploadUrls}
                          setProfileImageUploadUrls={setProfileImageUploadUrls}
                          profileImageUploadStatuses={profileImageUploadStatuses}
                          setProfileImageUploadStatuses={setProfileImageUploadStatuses}
                          localProfileImageUrls={localProfileImageUrls}
                          setLocalProfileImageUrls={setLocalProfileImageUrls}
                          profileUploadDataKeys={profileUploadDataKeys}
                          setProfileUploadDataKeys={setProfileUploadDataKeys}
                          myProfile={myProfile}
                        />
                      ) : (
                        <>
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                            <div className="flex justify-start w-48 sm:w-48 h-64 sm:h-64 aspect-[3/4]">
                              <ProfileImage profile={myProfile} />
                            </div>
                            <div>
                              <DisplayPropertyWithEdit
                                label="Bio"
                                name="bio"
                                value={bio ? bio : "Not Filled"}
                                editable={isAboutEditable}
                              />
                              <DisplayPropertyWithEdit
                                label="Partner Preferences"
                                name="userPreferences"
                                value={userPreferences ? userPreferences : "Not Filled"}
                                editable={isAboutEditable}
                              />
                            </div>
                          </div>
                          <div className="mt-4">
                            <DisplayPropertyWithEdit
                              label="Contact Number"
                              name="contact number"
                              value={contactNumber ? contactNumber : "Not Filled"}
                              editable={isAboutEditable}
                            />
                            <DisplayPropertyWithEdit
                              label="Contact Email"
                              name="contact email"
                              value={contactEmail ? contactEmail : "Not Filled"}
                              editable={isAboutEditable}
                            />
                          </div>
                          <div className="flex flex-col md:flex-row justify-start gap-2 mt-6">
                            <button
                              className="btn btn-primary"
                              onClick={handleOpen}
                            >
                              Update Password
                            </button>
                            <button className="btn btn-primary">
                              <Link
                                className="text-white no-underline"
                                to={"/favourites"}
                              >
                                View Favourite Profiles
                              </Link>
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </StepContent>
            </Step>
            {/* PERSONAL DETAILS */}
            <Step expanded={true} active={true} key={1}>
              <StepLabel
                StepIconComponent={SettingsAccessibilityIcon}
                className="text-blue-700"
              ></StepLabel>
              <StepContent>
                {myProfile && (
                  <div className="flex flex-col items-center mt-4 mb-4 space-y-4 bg-gray-100 shadow-md">
                    <div className="w-full p-4 rounded-lg">
                      <div className="flex justify-between items-center">
                        <h3 className="text-xl font-bold">Personal Details</h3>
                        <button
                          className="btn btn-primary btn-sm z-10"
                          onClick={() => {
                            if (validationError !== "personal") {
                              if (isPersonalEditable) {
                                updateProfileInBackEnd(() => {
                                  setIsPersonalEditable(false);
                                });
                              } else {
                                setIsPersonalEditable(true);
                              }
                            }

                          }}
                        >
                          {isPersonalEditable ? (
                            <Tooltip title="Save">
                              <DoneIcon className="text-white" />
                            </Tooltip>
                          ) : (
                            <Tooltip title="Edit">
                              <EditIcon className="text-white" />
                            </Tooltip>
                          )}
                        </button>
                      </div>

                      {isPersonalEditable ? (
                        <PersonalDetails
                          firstName={firstName}
                          lastName={lastName}
                          age={age}
                          gender={gender}
                          city={city}
                          state={state}
                          country={country}
                          handleChange={handleChange}
                          data={data}
                        />
                      ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                          <DisplayPropertyWithEdit
                            label="Name"
                            name="name"
                            value={name}
                            editable={isPersonalEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Age"
                            name="age"
                            value={age}
                            editable={isPersonalEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Gender"
                            name="gender"
                            value={gender}
                            editable={isPersonalEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="City"
                            name="city"
                            value={city}
                            editable={isPersonalEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="State"
                            name="state"
                            value={state}
                            editable={isPersonalEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Country"
                            name="country"
                            value={country}
                            editable={isPersonalEditable}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </StepContent>
            </Step>
            {/* FAMILY DETAILS */}
            <Step expanded={true} active={true} key={5}>
              <StepLabel
                StepIconComponent={FamilyRestroomIcon}
                className="text-blue-700"
              ></StepLabel>
              <StepContent>
                {myProfile && (
                  <div className="flex flex-col items-center mt-4 mb-4 space-y-4 bg-gray-100 shadow-md">
                    <div className="w-full p-4 rounded-lg">
                      <div className="flex justify-between items-center">
                        <h3 className="text-xl font-bold">Family Details</h3>
                        <button
                          className="btn btn-primary btn-sm z-10"
                          onClick={() => {
                            if (validationError !== "family") {
                              if (isFamilyEditable) {
                                updateProfileInBackEnd(() => {
                                  setIsFamilyEditable(false);
                                });
                              } else {
                                setIsFamilyEditable(true);
                              }
                            }
                          }}
                        >
                          {isFamilyEditable ? (
                            <Tooltip title="Save">
                              <DoneIcon className="text-white" />
                            </Tooltip>
                          ) : (
                            <Tooltip title="Edit">
                              <EditIcon className="text-white" />
                            </Tooltip>
                          )}
                        </button>
                      </div>

                      {isFamilyEditable ? (
                        <FamilyDetails
                          fatherName={fatherName}
                          fatherNumber={fatherNumber}
                          motherName={motherName}
                          motherNumber={motherNumber}
                          handleChange={handleChange}
                          data={data}
                        />
                      ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                          <DisplayPropertyWithEdit
                            label="Father Name"
                            name="fatherName"
                            value={fatherName ? fatherName : "Not Filled"}
                            editable={isFamilyEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Mother Name"
                            name="motherName"
                            value={motherName ? motherName : "Not Filled"}
                            editable={isFamilyEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Father's Number"
                            name="fatherNumber"
                            value={fatherNumber ? fatherNumber : "Not Filled"}
                            editable={isFamilyEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Mother's Number"
                            name="motherNumber"
                            value={motherNumber ? motherNumber : "Not Filled"}
                            editable={isFamilyEditable}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </StepContent>
            </Step>
            {/* CAREER DETAILS */}
            <Step expanded={true} active={true} key={2}>
              <StepLabel
                StepIconComponent={WorkIcon}
                className="text-blue-700"
              ></StepLabel>
              <StepContent>
                {myProfile && (
                  <div className="flex flex-col items-center mt-4 mb-4 space-y-4 bg-gray-100 shadow-md">
                    <div className="w-full p-4 rounded-lg">
                      <div className="flex justify-between items-center">
                        <h3 className="text-xl font-bold">Career Details</h3>
                        <button
                          className="btn btn-primary btn-sm z-10"
                          onClick={() => {
                            if (validationError !== "career") {
                              if (isCareerEditable) {
                                updateProfileInBackEnd(() => {
                                  setIsCareerEditable(false);
                                });
                              } else {
                                setIsCareerEditable(true);
                              }
                            }
                          }}
                        >
                          {isCareerEditable ? (
                            <Tooltip title="Save">
                              <DoneIcon className="text-white" />
                            </Tooltip>
                          ) : (
                            <Tooltip title="Edit">
                              <EditIcon className="text-white" />
                            </Tooltip>
                          )}
                        </button>
                      </div>

                      {isCareerEditable ? (
                        <CareerDetails
                          handleChange={handleChange}
                          data={data}
                          qualifications={qualifications}
                          occupation={occupation}
                          employedIn={employedIn}
                          annualIncome={annualIncome}
                          isNRI={isNRI}
                        />
                      ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                          <DisplayPropertyWithEdit
                            label="Occupation"
                            name="occupation"
                            value={occupation}
                            editable={isCareerEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Annual Income"
                            name="annualIncome"
                            value={annualIncome}
                            editable={isCareerEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Employed In"
                            name="employedIn"
                            value={employedIn}
                            editable={isCareerEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Qualification"
                            name="qualifications"
                            value={qualifications.toString()}
                            editable={isCareerEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Is NRI"
                            name="isNRI"
                            value={isNRI ? "Yes" : "No"}
                            editable={isCareerEditable}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </StepContent>
            </Step>
            {/* SOCIAL DETAILS */}
            <Step expanded={true} active={true} key={3}>
              <StepLabel
                StepIconComponent={GroupsIcon}
                className="text-blue-700"
              ></StepLabel>
              <StepContent>
                {myProfile && (
                  <div className="flex flex-col items-center mt-4 mb-4 space-y-4 bg-gray-100 shadow-md">
                    <div className="w-full p-4 rounded-lg">
                      <div className="flex justify-between items-center">
                        <h3 className="text-xl font-bold">Social Details</h3>
                        <button
                          className="btn btn-primary btn-sm z-10"
                          onClick={() => {
                            if (validationError !== "social") {
                              if (isSocialEditable) {
                                updateProfileInBackEnd(() => {
                                  setIsSocialEditable(false);
                                });
                              } else {
                                setIsSocialEditable(true);
                              }
                            }
                          }}
                        >
                          {isSocialEditable ? (
                            <Tooltip title="Save">
                              <DoneIcon className="text-white" />
                            </Tooltip>
                          ) : (
                            <Tooltip title="Edit">
                              <EditIcon className="text-white" />
                            </Tooltip>
                          )}
                        </button>
                      </div>

                      {isSocialEditable ? (
                        <SocialDetails
                          maritalStatus={maritalStatus}
                          motherTongue={motherTongue}
                          religion={religion}
                          caste={caste}
                          handleChange={handleChange}
                          data={data}
                          languagesKnown={languagesKnown}
                          gotra={gotra}
                          rashi={rashi}
                          kuldevta={kuldevta}
                          nakshatra={nakshatra}
                          math={math}
                        />
                      ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                          <DisplayPropertyWithEdit
                            label="Marital Status"
                            name="maritalStatus"
                            value={maritalStatus}
                            editable={isSocialEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Mother Tongue"
                            name="motherTongue"
                            value={motherTongue ? motherTongue : "Not Filled"}
                            editable={isSocialEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Caste"
                            name="caste"
                            value={caste ? caste : "Not Filled"}
                            editable={isSocialEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Gotra"
                            name="gotra"
                            value={gotra ? gotra : "Not Filled"}
                            editable={isSocialEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Kuldevta"
                            name="kuldevta"
                            value={kuldevta ? kuldevta : "Not Filled"}
                            editable={isSocialEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Nakshatra"
                            name="nakshatra"
                            value={nakshatra ? nakshatra : "Not Filled"}
                            editable={isSocialEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Rashi"
                            name="rashi"
                            value={rashi ? rashi : "Not Filled"}
                            editable={isSocialEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Math"
                            name="math"
                            value={math ? math : "Not Filled"}
                            editable={isSocialEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Languages Known"
                            name="languagesKnown"
                            value={languagesKnown.toString() ? languagesKnown.toString() : "Not Filled"}
                            editable={isSocialEditable}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </StepContent>
            </Step>
            {/* OTHER DETAILS */}
            <Step expanded={true} active={true} key={4}>
              <StepLabel
                StepIconComponent={InterestsIcon}
                className="text-blue-700"
              ></StepLabel>
              <StepContent>
                {myProfile && (
                  <div className="flex flex-col items-center mt-4 mb-4 space-y-4 bg-gray-100 shadow-md">
                    <div className="w-full p-4 rounded-lg">
                      <div className="flex justify-between items-center">
                        <h3 className="text-xl font-bold">Other Details</h3>
                        <button
                          className="btn btn-primary btn-sm z-10"
                          onClick={() => {
                            if (validationError !== "other") {
                              if (isOtherEditable) {
                                updateProfileInBackEnd(() => {
                                  setIsOtherEditable(false);
                                });
                              } else {
                                setIsOtherEditable(true);
                              }
                            }
                          }}
                        >
                          {isOtherEditable ? (
                            <Tooltip title="Save">
                              <DoneIcon className="text-white" />
                            </Tooltip>
                          ) : (
                            <Tooltip title="Edit">
                              <EditIcon className="text-white" />
                            </Tooltip>
                          )}
                        </button>
                      </div>

                      {isOtherEditable ? (
                        <OtherDetails
                          bloodGroup={bloodGroup}
                          height={height}
                          weight={weight}
                          foodHabits={foodHabits}
                          drinkHabits={drinkingHabits}
                          smokingHabits={smokingHabits}
                          handleChange={handleChange}
                          data={data}
                        />
                      ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                          <DisplayPropertyWithEdit
                            label="Blood Group"
                            name="bloodGroup"
                            value={bloodGroup ? bloodGroup : "Not Filled"}
                            editable={isOtherEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Height"
                            name="height"
                            value={height ? height : "Not Filled"}
                            editable={isOtherEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Weight"
                            name="weight"
                            value={weight ? weight : "Not Filled"}
                            editable={isOtherEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Food Habits"
                            name="foodHabits"
                            value={foodHabits ? foodHabits : "Not Filled"}
                            editable={isOtherEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Drink Habits"
                            name="drinkingHabits"
                            value={drinkingHabits ? drinkingHabits : "Not Filled"}
                            editable={isOtherEditable}
                          />
                          <DisplayPropertyWithEdit
                            label="Smoke Habits"
                            name="smokingHabits"
                            value={smokingHabits ? smokingHabits :"Not Filled"}
                            editable={isOtherEditable}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </StepContent>
            </Step>
          </Stepper>
        </Box>
      </div>
    </div>
  );
};

export default MyProfilePage;
